import React from 'react'
import {
    HiOutlineChartBar,
    HiOutlineCube,
    HiOutlineHome,
    HiOutlineOfficeBuilding,
    HiOutlineShieldCheck,
    HiOutlineUserGroup,
} from 'react-icons/hi'
import { MdOutlineWarehouse } from 'react-icons/md'
import { LiaShippingFastSolid } from 'react-icons/lia'
import { GiReceiveMoney } from 'react-icons/gi'

const menuItems = [
    {
        id: 0,
        label: 'Home',
        module: 'home',
        link: '/',
        icon: <HiOutlineHome size={20} />,
    },
    {
        id: 1,
        label: 'Maestro',
        module: 'maestro',
        icon: <HiOutlineCube size={20} />,
        children: [
            {
                id: 11,
                label: 'Sales Orders',
                module: 'sales-orders',
                link: '/maestro/sales-orders',
            },
            {
                id: 12,
                label: 'Inbound Delivery',
                module: 'inbound-delivery',
                link: '/maestro/inbound-delivery',
            },
            {
                id: 13,
                label: 'Products',
                module: 'products',
                link: '/maestro/products',
            },
            {
                id: 14,
                label: 'Transaction Log',
                module: 'transaction-log',
                link: '/maestro/transaction-log',
            },
            {
                id: 15,
                label: 'Cron Jobs',
                module: 'cron-jobs',
                link: '/maestro/cron-jobs',
            },
            {
                id: 16,
                label: 'File Directory',
                module: 'file-directory',
                link: '/maestro/file-directory',
            },
        ],
    },
    {
        id: 2,
        label: 'WMS',
        module: 'meson-wms',
        icon: <MdOutlineWarehouse size={20} />,
        children: [
            {
                id: 21,
                label: 'Meson - ASN',
                module: 'asn',
                link: '/meson-wms/asn',
            },
            {
                id: 22,
                label: 'Meson - Shipments',
                module: 'shipments',
                link: '/meson-wms/shipments',
            },
            {
                id: 23,
                label: 'Meson - Stock Holdings',
                module: 'stock-holdings',
                link: '/meson-wms/stock-holdings',
            },
        ],
    },
    {
        id: 4,
        label: 'Insights',
        module: 'meson-insights',
        icon: <HiOutlineChartBar size={20} />,
        children: [
            {
                id: 31,
                label: 'Dashboards - Inbound',
                module: 'inbound',
                link: '/dashboards/inbound-dashboard',
            },
            {
                id: 32,
                label: 'Dashboards - Outbound',
                module: 'outbound',
                link: '/dashboards/outbound-dashboard',
            },
            {
                id: 33,
                label: 'Dashboards - Inventory',
                module: 'inventory',
                link: '/dashboards/inventory-dashboard',
            },
            {
                id: 34,
                label: 'Dashboards - Performance',
                module: 'performance',
                link: '/dashboards/performance-dashboard',
            },
            {
                id: 34,
                label: 'Dashboards - Financials',
                module: 'financials',
                link: '/dashboards/financials-dashboard',
            },
            {
                id: 41,
                label: 'Reports - Inbound',
                module: 'inbound',
                link: '/meson-insights/inbound',
            },
            {
                id: 42,
                label: 'Reports - Outbound',
                module: 'outbound',
                link: '/meson-insights/outbound',
            },
            {
                id: 43,
                label: 'Reports - Inventory',
                module: 'inventory',
                link: '/meson-insights/inventory',
            },
            {
                id: 44,
                label: 'Reports - Performance',
                module: 'performance',
                link: '/meson-insights/performance',
            },
            {
                id: 34,
                label: 'Reports - Financials',
                module: 'financials',
                link: '/meson-insights/financials',
            },
        ],
    },
    {
        id: 7,
        label: 'TMS',
        module: 'transport',
        icon: <LiaShippingFastSolid size={20} />,
        children: [
            {
                id: 71,
                label: 'MACHSHIP - Consignments',
                module: 'machship',
                link: '/transport/machship',
            },
        ],
    },
    {
        id: 8,
        label: 'Finance',
        module: 'finacials',
        icon: <GiReceiveMoney size={20} />,
        children: [
            {
                id: 81,
                label: 'XERO - Invoicing',
                module: 'xero',
                link: '/finacials/xero',
            },
        ],
    },
    {
        id: 5,
        label: 'System Settings',
        module: 'company-management',
        icon: <HiOutlineOfficeBuilding size={20} />,
        children: [
            {
                id: 51,
                label: 'Company Setup',
                module: 'company',
                link: '/company-management/company',
            },
            {
                id: 52,
                label: 'Integration Type',
                module: 'integration-type',
                link: '/company-management/integration-type',
            },
            {
                id: 53,
                label: 'Integration',
                module: 'integration',
                link: '/company-management/integration',
            },
            {
                id: 56,
                label: 'Access Key',
                module: 'access-key',
                link: '/company-management/access-key',
            },
            {
                id: 59,
                label: 'Machship Setup',
                module: 'machship-integration',
                link: '/company-management/machship-integration',
            },
            {
                id: 60,
                label: 'Xero Setup',
                module: 'xero-integration',
                link: '/company-management/xero-integration',
            },
            {
                id: 65,
                label: 'Customer Setup',
                module: 'customers',
                link: '/company-management/customers',
                icon: <HiOutlineUserGroup size={20} />,
            },
            {
                id: 64,
                label: 'User Setup',
                module: 'users',
                link: '/company-management/users',
            },
            {
                id: 63,
                label: 'User Roles',
                module: 'roles',
                link: '/company-management/roles',
            },
            {
                id: 66,
                label: 'User Roles Permission',
                module: 'access',
                link: '/company-management/access',
                icon: <HiOutlineShieldCheck size={20} />,
            },
        ],
    },
]

export default menuItems
